import request from "@/lib/request/request";
import Model from "@/lib/model/model";
//职位组结构
export class JobInfo extends Model {
  jobId = 0; // 职位组id
  companyId = 0; // 公司id
  userId = 0; // 用户id
  connectCode = ""; // 职位组链接码 7开头
  name = ""; // 名称
  joinExamLimit = 0; // 允许面试职位个数 0不限制 >0限制个数
  joinExamLimitSwitch = false; // 冗余 不限制true 限制false
  joinCandidateLimitSwitch = false; //允许面试次数
  joinCandidateLimit = 0; //
  showReport = 2; // 是否允许查看报告
  replaceWsaCode = 0; // 是否替换面试二维码
  onlyWhiteLogin = 0; // 是否仅白名单候选人可登录
  companyName = ""; // 公司名
  companyLogoUrl = ""; // 公司Logo
  companyDesc = ""; // 公司描述
  companyColor = "#B81918"; // 颜色
  isDefaultConfig = 2; // 是否作为公司默认配置
  showReferenceAnswer = 2; //报告页是否展示参考答案
  loginText = ""; // 登录页文案
}
export class PP extends Model {
  key = "招聘类型";
  value = "社会招聘"; // 参数信息 目前固定大小1 且 key=招聘类型
}
//岗位结构
export class JobExam extends Model {
  jobExamId = 0; //唯一识别id
  jobId = 0; // 职位组id
  examId = ""; // 面试id
  name = ""; // 职位名称
  remark = ""; // 备注
  paramList: PP[] = [new PP()];
  sort = 0; // 排序 sort ASC, id ASC
  editing = false; //正在编辑中 前端用
}
//白名单结构
export class WhiteUser extends Model {
  whiteUserId = 0;
  jobId = 0;
  showName = "";
  phone = "";
  email = "";
}
export class CommonParam extends Model {
  companyId = 0;
  jobId = 0;
}
export class ExamJobItem extends Model {
  type = ""; // 链接类型  exam/job
  name = ""; // 名称
  connectUrl = ""; // 短信链接
  wsaCodeUrl = ""; // 小程序码链接
  examId = ""; // 面试id
  jobId = 0; // 职位组id
  connectCode = ""; // 职位组链接码 7开头
}

export default class Job extends Model {
  //职位组本身相关
  static getJobList(p: any) {
    return request.post("aiExam/job/list", p).then(res => {
      if (res.data.code === 0) {
        return res.data.data;
      }
    });
  }
  static getJobInfo(p: any) {
    return request.post("aiExam/job/get", p).then(res => {
      if (res.data.code === 0) {
        return res.data.data;
      }
    });
  }
  static createJob(p: any) {
    return request.post("aiExam/job/create", p).then(res => {
      return res.data;
    });
  }
  static updateJob(p: any) {
    return request.post("aiExam/job/update", p).then(res => {
      if (res.data.code === 0) {
        return true;
      }
    });
  }
  static updateJobName(p: any) {
    return request.post("aiExam/job/updateName", p).then(res => {
      if (res.data.code === 0) {
        return res.data.data;
      }
    });
  }
  static getJobExamList(p: any) {
    return request.post("aiExam/job/examList", p).then(res => {
      if (res.data.code === 0) {
        return res.data.data;
      }
    });
  }
  static deleteJob(p: any) {
    return request.post("aiExam/job/delete", p).then(res => {
      if (res.data.code === 0) {
        return true;
      }
    });
  }
  //职位组挂面试相关
  static createJobExam(p: any) {
    return request.post("aiExam/job/examCreate", p).then(res => {
      // return new DashTopData().assign(res.data.data);
    });
  }
  static updateJobExam(p: any) {
    return request.post("aiExam/job/examUpdate", p).then(res => {
      if (res.data.code === 0) {
        return res.data.data;
      }
    });
  }
  static deleteJobExam(p: any) {
    return request.post("aiExam/job/examDelete", p).then(res => {
      if (res.data.code === 0) {
        return res.data.data;
      }
    });
  }
  //职位组白名单相关
  static getWhiteList(p: any) {
    return request.post("aiExam/job/whiteUserList", p).then(res => {
      if (res.data.code === 0) {
        return res.data.data;
      }
    });
  }
  static createWhite(p: any) {
    return request.post("aiExam/job/whiteUserCreate", p).then(res => {
      if (res.data.code === 0) {
        return true;
      }
    });
  }
  static createWhiteM(p: any) {
    return request.post("aiExam/job/whiteUserMCreate", p).then(res => {
      if (res.data.code === 0) {
        return true;
      }
    });
  }

  static deleteWhite(p: any) {
    return request.post("aiExam/job/whiteUserDelete", p).then(res => {
      if (res.data.code === 0) {
        return true;
      }
    });
  }
  static deleteWhiteM(p: any) {
    return request.post("aiExam/job/whiteUserMDelete", p).then(res => {
      if (res.data.code === 0) {
        return true;
      }
    });
  }
  static sendWhite(p: any) {
    return request.post("aiExam/job/whiteUserSendMessage", p).then(res => {
      if (res.data.code === 0) {
        return true;
      }
    });
  }
  static sendWhiteM(p: any) {
    return request.post("aiExam/job/whiteUserMSendMessage", p).then(res => {
      if (res.data.code === 0) {
        return true;
      }
    });
  }

  static getAllId(p: any) {
    return request.post("aiExam/job/whiteUserListIds", p).then(res => {
      return res;
    });
  }
  //批量解析
  static parseWhiteM(p: any) {
    return request.post("aiExam/job/whiteUserMCreateParse", p).then(res => {
      if (res.data.code === 0) {
        return res.data;
      }
    });
  }

  static getAllExam(p: any) {
    return request.post("aiExam/exam2/smallList", p).then(res => {
      if (res.data.code === 0) {
        return res.data.data;
      }
    });
  }
  static sortJobExam(p: any) {
    return request.post("aiExam/job/examSort", p).then(res => {
      if (res.data.code === 0) {
        return res.data.data;
      }
    });
  }
  static getJobTemplate(p: any) {
    return request.post("aiExam/job/messageTemplateGet", p).then(res => {
      if (res.data.code === 0) {
        return res.data.data;
      }
    });
  }
  static saveJobTemplate(p: any) {
    return request.post("aiExam/job/messageTemplateSave", p).then(res => {
      if (res.data.code === 0) {
        return true;
      }
    });
  }

  static getJobUrl(p: any) {
    return request.post("aiExam/jobPublic/url", p).then(res => {
      if (res.data.code === 0) {
        return res.data.data;
      }
    });
  }
  static getJobImg(p: any) {
    return request.post("aiExam/jobPublic/wsaCode", p).then(res => {
      if (res.data.code === 0) {
        return res.data.data;
      }
    });
  }
  static getExamJobList(p: any) {
    return request.post("aiExam/exam/urlAndWsaCode", p).then(res => {
      if (res.data.code === 0) {
        const list: ExamJobItem[] = [];
        res.data.data.list.forEach((it: ExamJobItem) => {
          list.push(new ExamJobItem().assign(it));
        });
        return list;
      } else {
        return [];
      }
    });
  }
}
